module.exports = __webpack_public_path__ + "static/media/grin-tongue.6e20e1c1.svg";